export class PolicyBank {

    constructor(
      public AccountNumber: string,
      public AccountOwnerName: string,
      public AccountType: string,
      public BankLookupCode: string,
      public BankName: string,
      public BankSortCode: string,
      public BranchName: number,
      public BranchNumber: number,
      public IbanCode: number,
      public RoutingNumber: number,
      public SwiftCode: number,
      public IbanCodeLast4Digits: string,
    ) {}
}
